import { createSelector } from 'reselect';

import { Selector } from 'react-redux';
import { RootState } from '../../redux/model/rootStateModel';
import { AuthState } from './authTypes';
import { MeGetResponse } from '../model/authModel';
import { API_REQUEST_STATE } from '../../enums/apiRequestState';

const getRoot = (state: RootState) => state.auth;

export const isAuthenticated = createSelector<[Selector<RootState, AuthState>], boolean>(
  getRoot,
  (root: AuthState) => root.isAuthenticated,
);

export const apiMeRequestState = createSelector<[Selector<RootState, AuthState>], API_REQUEST_STATE>(
  getRoot,
  (root: AuthState) => root.apiMeRequestState,
);

export const me = createSelector<[Selector<RootState, AuthState>], MeGetResponse>(
  getRoot,
  (root: AuthState) => root.me,
);
